/**
 * Created by 枯荣<panjiankang@cai-inc.com> on 2019-08-08 11:04.
 */
const Regexp = {
  // 手机号
  mobild: /^(1(3|4|5|7|8)\d{9})$|^(\d{3}-\d{7,8}|\d{4}-\d{7,8})$/,
  // 邮箱
  email: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
  // 身份证
  id: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
  // 密码
  passward: /^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&*]+$)[a-zA-Z\d!@#$%^&*]{6,20}$/,
  // 银行卡号
  bankCardNo: /^([1-9]{1})(\d{14}|\d{15}|\d{16}|\d{17}|\d{18}|\d{19}|\d{20})$/
};

module.exports = Regexp;
